import toUTCLocalISOString from './utils/date';
import { toEmDash, toMinus, getEnDash } from './utils/string';

export default {
  name: 'hypo-vue-base-mixin',
  created() {
    this.componentName = this.$options.name;
  },
  methods: {
    namespaceClass(bem) {
      let className = this.componentName;
      if (bem) {
        let dash = '-';
        if (bem.charAt(0) === '-' || bem.charAt(0) === '_') {
          dash = '';
        }
        className += dash + bem;
      }
      return className;
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    toUTCLocalISOString(date) {
      return toUTCLocalISOString(date);
    },

    formatNumberSymbol(value) {
      if (value === null) {
        return toEmDash(value);
      }
      return toMinus(value);
    },

    getUILabel(labelId) {
      return labelId ? this.labeller.getLabel(labelId.toUpperCase()) : '';
    },

    getEnDash() {
      return getEnDash();
    },
  },
};
